import React from 'react';
import './Biocapteurs.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import i18n from '../../context/i18n';

const Biocapteurs: React.FC = () => {
  const { t } = useTranslation();

  const devices = t('biocapteurs.devices', { returnObjects: true }) as {
    title: string;
    description: string;
    indications?: string[];
    advantages?: string[];
  }[];

  const links = [
    {
      youtube: 'https://www.youtube.com/watch?v=0vycWQu3wkE',
      siteWeb: 'https://www.vivason.fr/votre-audition/test-auditif/lire-audiogramme',
      image: '/images/Audiogrammes.png'
    },
    {
      youtube: 'https://www.youtube.com/watch?v=mX54dCHD3cI',
      siteWeb: 'https://www.creative-sz.com/products/lepu-m12-medical-grade-telehealth-wearable-72-hours-holter-ecg-monitor',
      image: '/images/HolterECG.jpg'
    },
    {
      youtube: 'https://www.youtube.com/watch?v=DTL9FWwckzI',
      siteWeb: 'https://www.freestyle.abbott/fr-fr/accueil.html',
      image: '/images/Freestylelibre.png'
    }
  ];

  return (
    <section className="biocapteurs" id="biocapteurs" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="container">
        <div className="biocapteurs-header">
          <h2>{t('biocapteurs.title')}</h2>
          <p className="lead">{t('biocapteurs.lead')}</p>
        </div>

        <div className="devices-grid">
          {devices.map((device, index) => (
            <div key={index} className="device-card">
              <div className="device-image">
                <img src={links[index].image} alt={device.title} />
              </div>
              <h3 >{device.title}</h3>
              <p>{device.description}</p>

              {device.indications && (
                <div className="indications">
                  <h4>{t('biocapteurs.indicationsLabel')} :</h4>
                  <ul>
                    {device.indications.map((indication, i) => (
                      <li key={i}>{indication}</li>
                    ))}
                  </ul>
                </div>
              )}

              {device.advantages && (
                <div className="advantages">
                  <h4>{t('biocapteurs.advantagesLabel')} :</h4>
                  <ul>
                    {device.advantages.map((advantage, i) => (
                      <li key={i}>{advantage}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="device-footer">
                <div className="social-links">
                  <a href="https://wa.me/+22236600014" target="_blank" rel="noopener noreferrer" className="social-link whatsapp" aria-label="WhatsApp">
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </a>
                  <a href={links[index].youtube} target="_blank" rel="noopener noreferrer" className="social-link youtube" aria-label="YouTube">
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                </div>
                <button className="learn-more">
                  <a href={links[index].siteWeb} target="_blank" rel="noopener noreferrer">
                    {t('biocapteurs.more')}
                  </a>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Biocapteurs;
